import { ReportType } from "src/app/reports/interfaces/report.interface";
import { NineboxFeature } from "src/environments/features/ninebox.feature";
import { SsoFeature } from "src/environments/features/sso.feature";
import { QuestionTypeAvailabilityFeature } from "./features/question-type-availability.feature";
import { ProcessFeature } from "src/environments/features/process-feature";

export class EnvironmentModel {
    clientName: string;
    production: boolean;
    apiUrl: string;
    apiUrlTG4: string;
    logo: string;
    hideReports: boolean;
    azureAD: {
        clientId: string;
        tenantId: string;
        scope: string;
    };
    appflow: {
        appId: string;
        channel: string;
    };
    features: Features;
    brandingByHost?: {
        [hostname: string]: {
            logo: string;
            clientName?: string;
            apiUrl?: string;
            loginScreenImage?: string;
            themeScss?: string;
            favicon16x16?: string;
            favicon32x32?: string;
        };
    };
}

export class Features {
    hrChannel: boolean;
    tutorialMenu: boolean;
    showCalibrationFullReport: boolean;
    showDescriptionReport: boolean;
    hideEvolutionOfEvaluationAndRankFromFinalReport: boolean;
    reportsToHide: ReportType[];
    sendLimitFinalEvaluationRule: boolean;
    hideHireDate: boolean;
    hideFinalConceptTableFreeEvaluationEndYear: boolean;
    notePadWithAllUsers: boolean;
    hasGoalsInputOnSelfEval: boolean;
    highlightSelfOrManagerEvalAnswer: boolean;
    highlightSelfGoalsFinalGradeAnswer: boolean;
    nineBox: NineboxFeature;
    useTranslationOnOverallEvaluation: boolean;
    hideVideoInstructionsLabel: boolean;
    skipThreeSixtySelection: boolean;
    frozenStructureEnabled: boolean;
    hideGoalsOnGoalsReview: boolean;
    reopenSelectionEnabled: boolean;
    typeConfigDescriptionEnabled: boolean;
    scrollSeeEvalOnManagerEvalEnabled: boolean;
    setPossibleValuesEndYearAsENTranslate: boolean;
    andOrQuestionGroupAttributes: boolean;
    allUsersCanDeleteThreeSixtyEval: boolean;
    hideExternalEvalFromManagerCard: boolean;
    hideAmountTimeUserWasSelectedOn360: boolean;
    disableRelationColumn: boolean;
    forceCloseSelfEvaluationStep: boolean;
    dialogAlertToApproveEvaluatorsEnabled: boolean;
    sso = new SsoFeature();
    feedbackFeatureRefinement: boolean;
    questionTypeAvailability = new QuestionTypeAvailabilityFeature();
    showCorePrinciples: boolean;
    showSearchWithoutAddClick: boolean;
    showFinalResult: boolean;
    potentialTypeConfigEnabled: boolean;
    hideTwoPlusTwoOnFinalReportEnabled: boolean;
    isConsentGoalsEnabled: boolean;
    showFeedbackLanguagesConfig: boolean;
    showDashboardWelcome: boolean;
    hideTwoPlusTwoButton: boolean;
    hideQuestionNumber: boolean;
    showSkipTwoPlusTwoCoachingEvaluation: boolean;
    showNamedPromotionAndPriority: boolean;
    showPartnerCycleConfiguration: boolean;
    divide360UsersLitByArea: boolean;
    userAttributesOnProcessAllowed: boolean;
    mandatoryThreeSixtyAreaRule: boolean;
    filterByGroupedAttributes: boolean;
    showThreeSixtyEvaluationLimit: boolean;
    showAreaEvaluatorsCount: boolean;
    showNotifications: boolean;
    headEvaluationProcess: boolean;
    finalFeedbackProcess: boolean;
    aiReview: boolean;
    enableEmptyStateMessageByArea: boolean;
    reportsByEmail: boolean;
    disableBookButton: boolean;
    showNineboxPreview: boolean;
    showSelectedCountOnSelection360: boolean;
    hideAttributesFromUserSearchOn360: boolean;
    principlesConfiguration: boolean;
    hideOverallEvaluationCard: boolean;
    processAvailability = new ProcessFeature();
    cannotOpenProfile: boolean;
    showOnlyFinalFeedbackSeeReviewsOption: boolean;
    exportNineboxDisabled: boolean;
    showCalibrationHeaderCard: boolean;
    hideViewThreeSixtyRank: boolean;
    defaultShowMore: boolean;
    hideShowFeedbackSectionOnReport?: boolean;
    hideBoldConcept?: boolean;
    changeTitleColor?: boolean;
    hideSubordinateAnswerManagerEvaluation?: boolean;
    aiOverviewReview?: boolean;
    enableEmailSendModal?: boolean;

    showExportPdfBooks: boolean;
    showFinalNoteCommittee: boolean;
    calibrationHeaderItemsToHide: string[];
    directDownloads?: boolean = false;
    constructor(features: Partial<Features> = null) {
        if (features) {
            Object.keys(features).forEach((key) => (this[key] = features[key]));
        }
    }
}
